import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";

@inheritSerialization(BaseUUIDEntity)
export default class DeviceMerchant extends BaseUUIDEntity {

	@serialize
	@deserialize
	public merchant_code: string = "";

	@serialize
	@deserialize
	public merchant_name: string = "";

	@serialize
	@deserialize
	public device_id: string = "";

	@serialize
	@deserialize
	public user_profile: string = "";

	@serialize
	@deserialize
	public brand: string = "";

	@serialize
	@deserialize
	public model: string = "";

	@serialize
	@deserialize
	public status: boolean = false;

}
